import BaseWebSocketSubscriber from './base.websocket.subscriber'
import ReplayWebSocketSubscriber from './replay.websocket.subscriber'
import CertificateWebSocketSubscriber from './certificate.websocket.subscriber'

const MESSAGE_TYPES = {
  PATCH_PRESENTATION: 'patch-presentation',
}

class PresentationWebSocketSubscriber extends BaseWebSocketSubscriber {
  init() {
    this.listenEvents()
  }

  listenEvents() {
    this.socketClient.on(MESSAGE_TYPES.PATCH_PRESENTATION, this.onPatchPresentation.bind(this))
    new ReplayWebSocketSubscriber(this.socketClient).init()
    new CertificateWebSocketSubscriber(this.socketClient).init()
  }

  onPatchPresentation(data) {
    this.$store.dispatch('patchPresentationAction', data)
  }
}

export default PresentationWebSocketSubscriber
